const prod = "";
  const dev = "http://192.168.0.108:8949/api"
  // const dev = "http://192.168.4.171:8949/api"
  //  const dev = "http://localhost:8949/api"
  // const dev = "http://127.0.0.1:8949/api"


export const BASE_URL = process.env.NODE_ENV === "production" ? prod : dev;
